import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class GroupsMultiSelectListComponent implements IController {
  selectedIds: any;
  optionIds: any;
  excludeIds: any;
  hideTagsFilter: boolean;
  onChange: Function;

  private groupsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  private excludeKeys: any;
  public isSelectAll: boolean;
  public tags: string[] = [];
  public subFilterQueryMap;
  public includedSubFilters: string[];

  /* @ngInject */
  constructor(private $log, private $groups, private $infiniteScroll, private commonsService: CommonsService) {
  }

  $onInit() {
    this.groupsRef = this.$groups();
    this.loadLimit = 20;

    this.groupsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.groupsRef, this.loadLimit, {getFullData: true});

    this.subFilterQueryMap = {
      tagType: 'Group'
    }

    this.includedSubFilters = [];

    if (this.hideTagsFilter !== true) {
      this.includedSubFilters.push('tags');
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  onToggle(groupId, isSelected) {
    this.onChange({
      groupIds: isSelected ? _.concat(this.selectedIds || [], [groupId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== groupId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.optionIds) {
      this._reload();
    } else {
      this._search();
    }
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({groupIds: []});
    } else {
      this.onChange({groupIds: this.infiniteScroll?.getItems()?.map((group) => group.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(group => group.id), this.selectedIds);
    return this.isSelectAll;
  }

  onChangeFilters(tags) {
    this.tags = tags;
    this._reload();
  }

  private _reload() {
    this.groupsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }


  private _search() {
    this.infiniteScroll.search(this.queryString);
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      ids: this.optionIds,
      tag: this.tags,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.groups')
  .component('groupsMultiSelectList', {
    bindings: {
      selectedIds: '<',
      optionIds: '<?',
      excludeIds: '<?',
      hideTagsFilter: '<?',
      onChange: '&'
    },
    template: require('./groups-multi-select-list.html').default,
    controller: GroupsMultiSelectListComponent
  });
